/* @flow */
import {unescape} from 'lodash';

export default function sanitizeText(text: ?string): string {
  if (typeof text !== 'string') {
    return '';
  }
  return unescape(
    text.replace(/<\/?[^>]+>/g, '').replace('&#96;', '`').replace('&#x27;', "'")
  );
}
